import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminOverview() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-overview">
      <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#ff1493]">
        // System Status
      </div>
      <h2 className="mt-2 font-display text-2xl md:text-4xl tracking-tight">Overview</h2>
      <div className="mt-8 grid grid-cols-2 md:grid-cols-3 gap-px bg-[#2a1a3a] border border-[#2a1a3a]">
        {stats &&
          [
            ["Products", stats.products_count],
            ["Drop List", stats.drop_list_count],
            ["Notify", stats.notify_count],
            ["Contraband Reqs", stats.contraband_requests_count],
            ["Contacts", stats.contacts_count],
          ].map(([k, v]) => (
            <div key={k} className="bg-[#050010] p-5">
              <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#7a6a90]">{k}</div>
              <div className="mt-2 font-display text-3xl md:text-4xl tracking-tight">{v}</div>
            </div>
          ))}
      </div>
    </div>
  );
}
